$('[data-fancybox="gallery"]').fancybox({
  buttons: ["slideShow", "thumbs", "fullScreen", "share", "close"],
  loop: true,
  protect: true,
});

$(document).ready(function () {
  $("#slider-logo-app")
    .not(".slick-initialized")
    .slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

  // Assuming '#switchbtn' is your toggle switch
  $("#switchbtn").on("change", function () {
    var isChecked = $(this).is(":checked"); // Check if the checkbox is checked
    $(".span.slider.round.tabSwitch").css(
      "backgroundColor",
      isChecked ? "#FFFFFF !important" : "#f44427!important"
    );

    // Select all '.defaultImage' and '.colorImage' elements
    var defaultImages = $(".defaultImage");
    var colorImages = $(".colorImage");

    // Show or hide images based on the toggle state
    if (isChecked) {
      // Toggle is true, show '.colorImage' and hide '.defaultImage'
      defaultImages.css("display", "block");
      colorImages.css("display", "none");
    } else {
      // Toggle is false, show '.defaultImage' and hide '.colorImage'
      defaultImages.css("display", "none");
      colorImages.css("display", "block");
    }
  });

  $(".question-heading").click(function (evt) {
    evt.stopPropagation();
  });
  $(".tech-table__column-category.question").click(function () {
    $(`.${$(this).attr("answer-class")}.column-hide`).toggleClass("active");
    if ($(`.${$(this).attr("answer-class")}.column-hide`).hasClass("active")) {
      $(this).find(".more-less").html("Less");
    } else {
      $(this).find(".more-less").html("More");
    }
  });

  $(".tab-link").click(function () {
    var tabID = $(this).attr("data-tab");
    $(".tab-link").removeClass("active");
    $(".three-tab-content").removeClass("active");
    $(this).addClass("active");
    $("#tab-" + tabID).addClass("active");
  });

  $(".colorImage").hide();
  $(".tabSwitch").click(function () {
    $(".defaultImage").toggle();
    $(".colorImage").toggle();
  });

  $(".icon-click").on("click", function () {
    $(".defaultDesc").hide();
    $(".iconDesc").hide();
    $(".icon-click").removeClass("active");

    var dataId = $(this).data("id");
    // Show the corresponding icon description
    $("#" + dataId).show();
    // Add "active" class to the clicked icon
    $(this).addClass("active");
  });
});
